import React from 'react';
import Backend from '../../../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { Form, Row, Col } from 'reactstrap';
import { validationSchema } from './validation';
import helper from '../../../../../utils/helper';
import PasswordConfirmation from '../../../../UI/PasswordConfirmation';
import { sortBy } from 'lodash';
import { Alert, Button, Input } from '../../../../UI/Common';
import ReactSelect from '../../../../UI/ReactSelect';

const NewAlarmIndicatorPage = (props) => {
  const { remoteDevices, alarmIndicators, isSubmitting, t } = props;
  const form = {
    indicatorId: '',
    remoteId: '',
  };
  //prettier-ignore
  const onChangeRemoteStation = (value, setFieldTouched, setFieldValue) => {
    // setFieldTouched('remoteId', false);
    setFieldValue('remoteId', value);
    const result = sortBy(
      alarmIndicators
        .filter((a) => a.remoteId === value)
        .map((a) => a.indicatorId),
    );
    for (let index = 0; index < result.length; index++) {
      const i = result[index];
      if (index === 15) {
        setFieldValue('indicatorId', '');
        break;
      }
      if (index + 1 !== i) {
        setFieldValue('indicatorId', index + 1);
        break;
      }
      if (result[index + 1] - i !== 1) {
        setFieldValue('indicatorId', i + 1);
        break;
      }
    }
  };
  const [openModal, setOpenModal] = React.useState(false);
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onSubmit(values) {
    if (isRequireConfirmation) {
      setOpenModal(true);
    } else {
      props.onCreateAlarmIndicator(values);
    }
  }
  return (
    <Backend>
      <div className="content-inner">
        <Row>
          <Col>
            <Formik
              initialValues={form}
              validationSchema={validationSchema}
              onSubmit={(values) => onSubmit(values)}
            >
              {({
                values,
                handleChange,
                errors,
                setFieldTouched,
                setFieldValue,
                touched,
                handleSubmit,
              }) => {
                return (
                  <Form>
                    <PasswordConfirmation
                      isOpen={openModal}
                      onCancel={() => setOpenModal(false)}
                      onConfirm={() => {
                        setOpenModal(false);
                        props.onCreateAlarmIndicator(values);
                      }}
                    />
                    <ReactSelect
                      label="Remote Station"
                      options={remoteDevices}
                      value={values.remoteId}
                      onChange={({ value }) => {
                        onChangeRemoteStation(
                          value,
                          setFieldTouched,
                          setFieldValue,
                        );
                      }}
                      valueKey="id"
                      labelKey="description"
                      getOptionLabel={(obj) => (
                        <div>
                          <p style={{ marginTop: 0, marginBottom: '0.5rem' }}>
                            {obj.label}
                          </p>
                          <p
                            style={{
                              marginTop: 0,
                              marginBottom: '0.5rem',
                              fontSize: '0.75rem',
                              fontStyle: 'italic',
                            }}
                          >
                            {obj.serialNo}
                          </p>
                        </div>
                      )}
                      invalid={errors.remoteId && touched.remoteId}
                      error={errors.remoteId}
                    />
                    <Input
                      required
                      label="Indicator ID"
                      id="indicatorId"
                      onChange={handleChange('indicatorId')}
                      value={values.indicatorId}
                      invalid={errors.indicatorId && touched.indicatorId}
                      error={errors.indicatorId}
                    />
                    <Alert.Error text={props.errors} />
                    <Button
                      id="create-alarm-indicator"
                      loading={isSubmitting}
                      onClick={(e) => {
                        e.preventDefault();
                        handleSubmit();
                      }}
                    >
                      <i className="md-icon">done</i>
                      {t('Create')}
                    </Button>
                  </Form>
                );
              }}
            </Formik>
          </Col>
          <Col />
        </Row>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(NewAlarmIndicatorPage);
